



import Vue from 'vue'
import Component from 'vue-class-component'
import { notify, Colors } from '@/modules/core/notification';

@Component
export default class NotFoundPage extends Vue {
    public created () {
        notify('La sección no existe o no esta disponible', Colors.Warning, {
            notShowInCenter: true,
        })

        this.$router.push({name: 'dashboard'})
    }
}
